<!--
 * Path: src/features/browser/forms/link/LinkEdit.vue
 * Task: Renders sub-form input elements for binding Document names and URL pairs using Vue 3.4+ defineModel.
 * Update: Removed local info button, as it is now handled by the block wrapper.
-->
<template>
  <div class="d-flex align-center">
    <!-- URL input field -->
    <v-text-field
      v-model="url"
      label="Document URL"
      variant="outlined"
      density="compact"
      hide-details
      class="me-2 flex-grow-1"
      placeholder="https://example.com"
    ></v-text-field>

    <!-- Name input field -->
    <v-text-field
      v-model="name"
      label="Document Name"
      variant="outlined"
      density="compact"
      hide-details
      class="me-2 flex-grow-1"
      placeholder="Link Text"
    ></v-text-field>

    <!-- Open button -->
    <v-tooltip location="top" text="Open Link in new tab">
      <template v-slot:activator="{ props: tooltipProps }">
        <v-btn
          v-bind="tooltipProps"
          icon="mdi-open-in-new"
          variant="text"
          :disabled="!url"
          @click="openLink"
          color="primary"
          size="small"
        ></v-btn>
      </template>
    </v-tooltip>
  </div>
</template>

<script setup lang="ts">
/**
 * Path: src/features/browser/forms/link/LinkEdit.vue
 * Task: Component controller that defines reactive bindings and safe tab redirection helpers.
 */

const url = defineModel<string>('url', { default: '' });
const name = defineModel<string>('name', { default: '' });

const openLink = (): void => {
  if (url.value) {
    let targetUrl = url.value;
    if (!/^https?:\/\//i.test(targetUrl)) {
      targetUrl = 'https://' + targetUrl;
    }
    window.open(targetUrl, '_blank');
  }
};
</script>
